export function useToast() {
   type Toast = {
      id?: number | string;
      status: "success" | "error" | "warning";
      messageEmoji?: string;
      message: string;
      callback?: Function;
      isToastButton?: boolean;
      toastButtonText?: string;
      duration?: number | undefined;
   }
   /**
    * State for a list of toasts being pushed from any where in the app
    */
   const toastsList = useState<Toast[]>("toastsList", () => []);
   const ongoingTimers = useState("ongoingTimers", () => []);

   /**
    * @function addToast to add a toast to the @constant toastsList by pushing to it.
    * @param toast is an object with some properties like message, actions, duration.
    */
   const addToast = (toast: Toast): void => {
      toastsList.value.push(toast);
      if (toast?.duration && toast.duration > 0) {
         startTimerForToast(toast);
      }
   };

   /**
    * @function removeToast to remove a toast from the @constant toastsList by splice.
    * @param toast is an object with some properties like message, actions, duration.
    */
   const removeToast = (toastId: Toast['id']) => {
      const toastIndex = toastsList.value.findIndex(
         (item) => item.id === toastId
      );
      if (toastIndex > -1) toastsList.value.splice(toastIndex, 1);
   };

   /**
    * @function startTimerForToast to set a timeout of duration equal to toast's duration and remove the toast from the state toastsList on completion.
    */
   const startTimerForToast = (toast: Toast) => {
      setTimeout(() => {
         removeToast(toast.id);
      }, toast.duration);
   };

   return { toastsList, addToast, removeToast };
}
